import React, { useEffect, useState } from "react";
import {EmbedSchedule} from "../../components/Embed/EmbedComponent";

const EmbedView = () => {
    return (<EmbedSchedule />)
}

export default EmbedView;